import { render } from "./EpisodeList.vue?vue&type=template&id=e5ab1f72&scoped=true"
import script from "./EpisodeList.vue?vue&type=script&lang=js"
export * from "./EpisodeList.vue?vue&type=script&lang=js"

import "./EpisodeList.vue?vue&type=style&index=0&id=e5ab1f72&lang=scss&scoped=true"

import exportComponent from "/Users/n0m4dz/workspace/projects/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5ab1f72"]])

export default __exports__